export default class Address {
  constructor({ line1, line2, city, state, zipCode }) {
    this.line1 = line1;
    this.line2 = line2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
  }

  toLuminisApiObject() {
    return {
      line1: this.line1,
      line2: this.streetAddressLine2,
      city: this.city,
      state: this.state,
      zipCode: this.zipCode,
    };
  }
}
